'use strict';

export function changePasswordCtrl ($scope, $rootScope, $state,$cookies,AuthenticationService,MenuService,$stateParams) {
       
    $scope.CTRLNAME='changePasswordCtrl';
    let touched=[false,false]
    AuthenticationService.ClearCredentials();
    
    let vueLogin =  new Vue({
        el: '#loginForm',
        data: {
          signupSuccess: false,
          errorMsg: '',
          digest: $stateParams.digest,
          dataLoading: false,
          passwordInvalid:[false,false],
          password:['','']
        },

        
      methods: { 
         checkPasswordValidity:function(i) { 
             //touched[i]=true       
             //if (this.password[i]=='' || this.password[i]==undefined || this.password[i]==null) this.passwordInvalid[i]= true;
             //else this.passwordInvalid[i]=false;
             //if (!this.password[i] && touched[i]==true
             //passwords must match
             if ( (i===1) && this.password[0]!==this.password[1]) this.passwordInvalid[i]=true
        },
        login:function() {
          
          let vm = this;
          AuthenticationService.PswReset(this.digest, this.password[0],this.password[1], function(response) {
      
            if(response.success) {
                
                //AuthenticationService.SetCredentials(response.data, vm.username,vm.password);
                vm.signupSuccess=true
   
                }
                else {
                     
                  vm.errorMsg = response.message;
                  setTimeout(function(){
                    vm.errorMsg="";
                    },10000);
                  vm.dataLoading = false;
                }
          });

        }
      
    },
    computed: {
        validity: function () {
            return this.reg.test(this.email)
    }
    },
    mounted(){
      
    }
    
  });
      
    }

changePasswordCtrl.$inject=['$scope', '$rootScope', '$state','$cookies','AuthenticationService','MenuService','$stateParams'];


  export function changePasswordRequestCtrl ($scope, $rootScope, $state,$cookies,AuthenticationService,MenuService) {
       
    $scope.CTRLNAME='changePasswordRequestCtrl';
    AuthenticationService.ClearCredentials();
    
    let vueLogin =  new Vue({
        el: '#loginForm',
        data: {
          reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
          signupSuccess: false,
          errorMsg: '',
          dataLoading: false,
          emailInvalid:false,
          email:''
        },
      
      methods: {
         isEmailValid: function() {
            return (this.email == "")? "" : (this.reg.test(this.email)) ? 'is-valid' : 'is-invalid';
            },
          hideError: function() {
       
        },
        checkEmailValidity: function() {
         this.errorMsg=''
         if (this.email=='' || this.email==undefined || this.email==null) this.emailInvalid= true;
         else this.emailInvalid=false; 
        },
        login:function() {
          
          let vm = this;
          AuthenticationService.RequestPswReset(this.email, function(response) {
      
            if(response.success) {
                
                //AuthenticationService.SetCredentials(response.data, vm.username,vm.password);
                vm.signupSuccess=true
   
                }
                else { 
                  vm.errorMsg = response.message;
                /*  setTimeout(function(){
                    vm.errorMsg="";
                    },10000);*/
                  vm.dataLoading = false;
                }
          });

        }
      
    },
    computed: {
        validity: function () {
            return this.reg.test(this.email)
    }
    },
    mounted(){
    
      
    }
    
  });
      
    }

  changePasswordRequestCtrl.$inject=['$scope', '$rootScope', '$state','$cookies','AuthenticationService','MenuService'];

  
export default function loginCtrl ($scope, $rootScope, $state,$cookies,AuthenticationService,MenuService,$location) {
    
    AuthenticationService.ClearCredentials();
   
    
    
    let vueLogin =  new Vue({
        el: '#loginForm',
        data: {
          errorMsg: '',
          dataLoading: false,
          usernameInvalid:false,
          passwordInvalid:false,
          username:'',
          password:'',
          query_hash:'',
        },
      
      methods: {
        checkUsernameValidity: function() {
         if (this.username=='' || this.username==undefined || this.username==null) this.usernameInvalid= true;
         else this.usernameInvalid=false; 
        },
        checkPasswordValidity:function() {
         if (this.password=='' || this.password==undefined || this.password==null) this.passwordInvalid= true;
         else this.passwordInvalid=false;
        },
        login:function() {
          //this.errorMsg = 'Miro eror!';
          let vm = this;
          //import {AuthenticationClass,Login} from './authModule';    
          //const authCls = new AuthenticationClass();
          //authCls.Login(this.username,this.password, function(response){
          vm.dataLoading=true;
          AuthenticationService.Login(this.username, this.password, function(response) {
      
            if(response.success) {
                
                AuthenticationService.SetCredentials(response.data.data, vm.username,vm.password);
                  vm.dataLoading=true;
                 //load menus
                
                
                var eth_address = $rootScope.globals.currentUser.organisation.ETHAccount;
                var use_blockchain = $rootScope.globals.currentUser.uep.use_blockchain;
                //"0xc30c523a8eee10e36beb7a6d07c636e02762cb27";
                if (use_blockchain){
                    if (eth_address!=null && eth_address.trim()!="" && use_blockchain)
                    {
                        MenuService.LoadMenus($scope).then(function () { });
                    }
                    else
                    {
                        var lang = $rootScope.globals.currentUser.lang;
                        var stateName = 'app.navbar.home';           
                        var navbar=MenuService.getNavbarByTargetName(stateName,lang);
                        var params = {'navbar_id':navbar};
                        $state.go(stateName,params);
                        
                    }
                }else MenuService.LoadMenus($scope).then(function () { });
            }
            else {
                     
                  vm.errorMsg = response.message;
                 // setTimeout(function(){
                  //  vm.errorMsg="";
                  //  },10000);
                  vm.dataLoading = false;
                }
          });

        }
      
    },
    mounted(){
    
     //get querystring
     this.query_hash=$location.search().demo;
    
     if (this.query_hash=="hfudhfdis7f89dszfh43hkjhfs87fd7zh45uhfsiu439")
     {
        this.username = "demo_user";
        this.password = "demouser!";
        this.login();
     }
      //import {AuthenticationClass,Login} from './authModule';
      
    }
    
  });
      
    }

  loginCtrl.$inject=['$scope', '$rootScope', '$state','$cookies','AuthenticationService','MenuService','$location'];

export function logoutCtrl ($scope,$rootScope, $state, AuthenticationService, MessagingService,ProcessingService) {
        // reset login status
      $scope.CTRLNAME='logoutCtrl';
      $scope.ac={
         alerts : []
         };
          
       AuthenticationService.Logout(function(response) {
         $scope.activity.activityMessage = ProcessingService.setActivityMsg('Logging out...');
         if(response.success) {
              AuthenticationService.ClearCredentials();
              
              MessagingService.clearAllMessages();
              $scope.activity.activityMessage = ProcessingService.setActivityMsg('');
         }else
         {
             $scope.errorMsg = response.message;
                
            
        }
      //  spinnerService._unregister('html5spinner');
        
       });
    
    
    
       // User.signOut();
        // $state.go('app.logout');
                    
        };

logoutCtrl.$inject=['$scope', '$rootScope', '$state','AuthenticationService','MessagingService','ProcessingService'];

